import React from "react";

const Dashtable = () => {
  return (
    <React.Fragment>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
          <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
            Top Performing Pages
          </h2>
          <div className="overflow-auto">
            <table className="min-w-[640px] w-full">
              <thead>
                <tr className="ltr:text-left rtl:text-right">
                  <th>Page Name</th>
                  <th>Clicks</th>
                  <th>Sessions</th>
                  <th>% Change</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-muted">
                  <td>http://sliced.com/Index.html</td>
                  <td>55</td>
                  <td>2952</td>
                  <td>
                    27%{" "}
                    <span className="px-1 text-xs font-bold rounded bg-success/10 text-success">
                      3.8%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>http://google.com</td>
                  <td>229</td>
                  <td>2392</td>
                  <td>
                    65%{" "}
                    <span className="px-1 text-xs font-bold rounded bg-success/10 text-success">
                      7.9%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>http://facebook.com/Index.html</td>
                  <td>12</td>
                  <td>2792</td>
                  <td>
                    37%{" "}
                    <span className="px-1 text-xs font-bold rounded bg-danger/10 text-danger">
                      19.8%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>http://twitter.com</td>
                  <td>239</td>
                  <td>6534</td>
                  <td>
                    74%{" "}
                    <span className="px-1 text-xs font-bold rounded bg-danger/10 text-danger">
                      23.3%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>http://github.com/Index.html</td>
                  <td>53</td>
                  <td>3434</td>
                  <td>
                    71%{" "}
                    <span className="px-1 text-xs font-bold rounded bg-success/10 text-success">
                      46.2%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>http://instagram.com</td>
                  <td>65</td>
                  <td>123</td>
                  <td>
                    69%{" "}
                    <span className="px-1 text-xs font-bold rounded bg-danger/10 text-danger">
                      6.89%
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
          <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
            Users by Countries
          </h2>
          <div className="overflow-auto">
            <table className="min-w-[640px] w-full">
              <thead>
                <tr className="ltr:text-left rtl:text-right">
                  <th>Countries Name</th>
                  <th>Device</th>
                  <th>Age</th>
                  <th>Sessions</th>
                </tr>
              </thead>
              <tbody>
                <tr className="text-muted">
                  <td>Ireland</td>
                  <td>Desktop</td>
                  <td>18</td>
                  <td>
                    2.3K{" "}
                    <span className="px-1 text-xs font-bold rounded bg-success/10 text-success">
                      3.8%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>United States</td>
                  <td>Mobile</td>
                  <td>24 - 36</td>
                  <td>
                    879{" "}
                    <span className="px-1 text-xs font-bold rounded bg-success/10 text-success">
                      7.9%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>Germany</td>
                  <td>Tablet</td>
                  <td>50</td>
                  <td>
                    340{" "}
                    <span className="px-1 text-xs font-bold rounded bg-danger/10 text-danger">
                      19.8%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>United Kingdom</td>
                  <td>Desktop</td>
                  <td>24 - 36</td>
                  <td>
                    5.4K{" "}
                    <span className="px-1 text-xs font-bold rounded bg-danger/10 text-danger">
                      23.3%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>India</td>
                  <td>Tablet</td>
                  <td>18</td>
                  <td>
                    1.3K{" "}
                    <span className="px-1 text-xs font-bold rounded bg-success/10 text-success">
                      46.2%
                    </span>
                  </td>
                </tr>
                <tr className="text-muted">
                  <td>Singapore</td>
                  <td>Mobile</td>
                  <td>18 - 24</td>
                  <td>
                    699{" "}
                    <span className="px-1 text-xs font-bold rounded bg-danger/10 text-danger">
                      6.89%
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashtable;
